// Constants for demo grid components
export const DEMO_GRID_CONFIG = {
  MONTHS_TO_SHOW: 9,
  CELL_SIZE: {
    MOBILE: "w-3 h-3",
    DESKTOP: "w-4 h-4"
  },
  CELL_GAP: {
    MOBILE: "gap-[2px]",
    DESKTOP: "gap-1"
  },
  WEEKDAY_COLUMN: {
    MOBILE: "w-4",
    DESKTOP: "w-6"
  },
  ROW_HEIGHT: {
    MOBILE: "15px",
    DESKTOP: "20px"
  }
} as const; 